const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

async function request(path, opts = {}) {
  const url = `${BASE_URL}${path}`;
  try {
    const res = await fetch(url, opts);
    let data = null;
    try {
      data = await res.json();
    } catch (e) {
      // no json body
    }
    return { ok: res.ok, status: res.status, data };
  } catch (error) {
    return { ok: false, status: 0, error: error.message || String(error) };
  }
}

export async function login(userId, password) {
  return request('/member/login/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username: userId, password }),
  });
}

export async function signup(userId, password, phone, school) {
  return request('/member/signup/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, password , tel: phone, nickname: school}),
  });
}

export default { login, signup };

export async function availability(userId, nickname) {
  const qs = [];
  if (userId) qs.push(`user_id=${encodeURIComponent(userId)}`);
  if (nickname) qs.push(`nickname=${encodeURIComponent(nickname)}`);
  const query = qs.length ? `?${qs.join('&')}` : '';
  return request(`/member/check/${query}`, { method: 'GET' });
}

export async function fetchLatestTemplate() {
  return request('/downloads/list/', { method: 'GET' });
}

/** 다운로드용 Signed URL 조회 (type=windows | type=android) */
export async function fetchDownloadUrl(type) {
  return request(`/downloads/download-url/?type=${encodeURIComponent(type)}`, { method: 'GET' });
}

// helper that injects access token from localStorage
export async function fetchWithAuth(path, opts = {}) {
  const token = localStorage.getItem('accessToken');
  const headers = opts.headers ? { ...opts.headers } : {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return request(path, { ...opts, headers });
}

export async function fetchIssuedVerificationCodes() {
  return fetchWithAuth('/verification/issued/', { method: 'GET' });
}
